(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import produce from "immer";
import combineReducers from "../utils/combineReducers";
import { reducer as SearchReducer } from "../modules/Search";
import { reducer as AppReducer } from "../modules/App";
import { reducer as BrowserHistoryReducer } from "../modules/BrowserHistory";
import { reducer as TranslationReducer } from "../modules/Translation";

const _default = combineReducers(produce, {
  app: AppReducer,
  search: SearchReducer,
  browserHistory: BrowserHistoryReducer,
  translation: TranslationReducer
});

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/store/rootReducer.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();